var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_5738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3569 6.11215C13.6142 6.11215 16.5192 7.94282 17.9373 10.8392C17.4302 11.8878 16.7169 12.7902 15.866 13.5208L17.0778 14.7326C18.2725 13.6755 19.2179 12.3519 19.8109 10.8392C18.3241 7.06616 14.6542 4.39321 10.3569 4.39321C9.26537 4.39321 8.21683 4.56511 7.22845 4.88311L8.64656 6.30123C9.2052 6.1895 9.77245 6.11215 10.3569 6.11215ZM9.43726 7.09195L11.2163 8.87105C11.7062 9.08591 12.1016 9.48127 12.3164 9.97117L14.0955 11.7503C14.1643 11.458 14.2159 11.1486 14.2159 10.8306C14.2244 8.69915 12.4883 6.97162 10.3569 6.97162C10.0389 6.97162 9.73807 7.01459 9.43726 7.09195ZM1.77089 4.28148L4.07424 6.58486C2.67332 7.68498 1.56462 9.14608 0.902832 10.8392C2.3897 14.6123 6.05959 17.2852 10.3569 17.2852C11.6633 17.2852 12.9181 17.036 14.0697 16.5805L17.0091 19.5199L18.2209 18.308L2.98272 3.06104L1.77089 4.28148ZM8.21683 10.7275L10.46 12.9707C10.4256 12.9793 10.3913 12.9879 10.3569 12.9879C9.17083 12.9879 8.20823 12.0253 8.20823 10.8392C8.20823 10.7963 8.21683 10.7705 8.21683 10.7275ZM5.29467 7.8053L6.79872 9.30938C6.60104 9.78208 6.48932 10.2978 6.48932 10.8392C6.48932 12.9707 8.22542 14.7068 10.3569 14.7068C10.8983 14.7068 11.414 14.5951 11.8781 14.3974L12.7204 15.2397C11.9641 15.446 11.1734 15.5663 10.3569 15.5663C7.09953 15.5663 4.19456 13.7356 2.77645 10.8392C3.37807 9.61019 4.25472 8.59602 5.29467 7.8053Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_5738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.627,
    height: 20.6273,
    fill: "white",
    transform: "translate(0.0429688 0.957031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHideIcon);
export default __webpack_public_path__ + "static/media/password_hide_icon.13b72c199d16a02f9f293bd465562d0b.svg";
export { ForwardRef as ReactComponent };